var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"danger","block":""},on:{"click":_vm.reset}},[_c('b-icon-box-arrow-left'),_vm._v(" Reset App")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }